export class hcpClass {
  id: number;
  name: string;
  visitsPerPlan: number;
  isHcpClass: boolean;
}
